module.exports = __webpack_public_path__ + "img/renta4-dark.c68154f4.png";